exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".screen__icon-container__2IAwc{position:absolute;z-index:1;top:0;right:0;bottom:0;left:0}.screen__icon-container__2IAwc,.screen__icon-container__2IAwc .screen__icon__3ZvpB{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.screen__icon-container__2IAwc .screen__icon__3ZvpB{font-size:9px;line-height:9px;position:relative;animation-name:screen__fade-out__zUQUX;animation-duration:.5s;opacity:0;border-radius:100px;background-color:rgba(0,0,0,.5)}.screen__icon-container__2IAwc .screen__animated-icon__2lV3R{animation-name:screen__icon-size__23_l0;animation-duration:.5s}.screen__icon-container__2IAwc .screen__play-icon__4-PXY{position:relative;left:3px}.screen__icon-container__2IAwc .screen__pause-icon__vx5ln{margin:5px 0}.screen__icon-container__2IAwc .screen__seconds__1Msme{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;min-width:5px;min-height:8px;color:#fff;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.screen__icon-container__2IAwc .screen__seconds__1Msme span{display:block}@keyframes screen__icon-size__23_l0{0%{width:22px;height:22px}to{width:30px;height:30px}}@keyframes screen__fade-out__zUQUX{0%{width:22px;height:22px;padding:19px;opacity:.9}to{font-size:14px;line-height:14px;width:30px;height:30px;padding:25px;opacity:0}}.screen__screen-block___8IMN{position:absolute;z-index:5;top:0;right:0;bottom:0;left:0;width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"icon-container": "screen__icon-container__2IAwc",
	"iconContainer": "screen__icon-container__2IAwc",
	"icon": "screen__icon__3ZvpB",
	"fade-out": "screen__fade-out__zUQUX",
	"fadeOut": "screen__fade-out__zUQUX",
	"animated-icon": "screen__animated-icon__2lV3R",
	"animatedIcon": "screen__animated-icon__2lV3R",
	"icon-size": "screen__icon-size__23_l0",
	"iconSize": "screen__icon-size__23_l0",
	"play-icon": "screen__play-icon__4-PXY",
	"playIcon": "screen__play-icon__4-PXY",
	"pause-icon": "screen__pause-icon__vx5ln",
	"pauseIcon": "screen__pause-icon__vx5ln",
	"seconds": "screen__seconds__1Msme",
	"screen-block": "screen__screen-block___8IMN",
	"screenBlock": "screen__screen-block___8IMN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/sass-loader/lib/loader.js!./~/video-player/dist/src/ui/screen/screen.scss
// module id = 1632
// module chunks = 1 2 3